<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.sop_name" [ttModel]="edit.sop_name"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="sopcl_name" [(ttModel)]="edit.sopcl_name"></tt-input>
        <tt-input-number ttLabel="orderby" [(ttModel)]="edit.orderby" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="sopcl_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
